module.exports = __webpack_public_path__ + "static/media/laugh-wink.ef4a7db3.svg";